import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getWpConnection(websiteId) {
  return axios.get(`/ajax/websites/${websiteId}/wp_connection`)
}

export function registerWpConnection(websiteId, data) {
  return axios.post(`/ajax/websites/${websiteId}/wp_connection/register`, data)
}

export function testWpConnection(websiteId) {
  return axios.post(`/ajax/websites/${websiteId}/wp_connection/test`)
}

export function destroyWpConnection(websiteId) {
  return axios.delete(`/ajax/websites/${websiteId}/wp_connection`)
}
